












import Vue from 'vue'
import FooterItem from './components/organisms/FooterItem.vue'
import HeaderItem from './components/organisms/HeaderItem.vue'
import NewHeaderItem from './components/organisms/NewHeaderItem.vue'
import NewFooterItem from './components/organisms/NewFooterItem.vue'

export default Vue.extend({
  components: {
    FooterItem,
    HeaderItem,
    NewHeaderItem,
    NewFooterItem,
  },
  computed: {
    isNewDesignPage(): boolean {
      if (!this.$route.name && window.location.pathname.startsWith('/new/')) {
        return true
      }
      if (this.$route.name === 'new_contents_manabi' || this.$route.name === 'manabi_grade' || this.$route.name === 'overseas_downloads_grade' || this.$route.name === 'new_overseas_downloads') {
        return true
      }
      if (this.$route.name === 'play_video' && this.$store.state.prevPath?.startsWith('/new/contents')) {
        return true
      }
      return false
    }
  },
  methods: {
    loadTypekitForNewDesign(): void {
      const kitId = 'wgt2ttw'
      const scriptId = 'typekit-new-design'
      if (document.getElementById(scriptId)) return
      const tk = document.createElement('script')
      tk.id = scriptId
      tk.src = `https://use.typekit.net/${kitId}.js`
      tk.async = true
      tk.onload = () => {
        try { (window as any).Typekit.load({ kitId, async: true }) } catch (e) { /* noop */ }
      }
      document.head.appendChild(tk)
    }
  },
  // 新デザインページの場合は画面右下のコナン君の画像を新たな画像へ変更
  // 新デザインページの場合はTypekitのkit(wgt2ttw)を読み込む
  watch: {
    isNewDesignPage: {
      immediate: true,
      handler(val: boolean) {
        // 新デザインページでは背景を白に、旧デザインページでは元に戻す
        document.body.style.backgroundImage = val ? 'none' : ''
        document.body.style.backgroundColor = val ? '#ffffff' : ''
        const pagetop = document.querySelector('#btnPagetop') as HTMLElement | null
        if (pagetop) {
          const img = pagetop.querySelector('img') as HTMLImageElement | null
          if (img) {
            img.src = val ? '/image/common/new-pagetop.png' : '/image/common/pagetop.png'
            img.style.width = val ? '100%' : ''
            img.style.height = val ? '100%' : ''
            img.style.objectFit = val ? 'contain' : ''
          }
          pagetop.style.zIndex = val ? '99' : ''
        }
        if (val) {
          this.loadTypekitForNewDesign()
        }
      }
    }
  }
})
